import { useState, useEffect, useRef } from 'react'
import { AgencyItem } from "./AgencyItem";

export const UserAccreditingAgencies = ({ userID }) => {

  const [ demographicData, setDemographicData ] = useState({})
  const [ agencies, setAgencies ] = useState([])
  const [ counter, setCounter ] = useState(1)

  useEffect(() => {
    setTimeout(() => {
      setDemographicData( tangibleFields.store.getValue("tgbl_user_demographic_data") )

      const agencies = []
      const agencyIds = []
      tangibleFields.store.getValue("tgbl_user_agency_data").forEach(item => {
        agencyIds.push( item.agency.value )
        setCounter(old => {
          agencies.push({ counter: old, data: item })
          return old + 1
        })
      })

      tangibleFields.store.setValue('exclude_agencies', agencyIds)
      tangibleFields.trigger( 'updateAgencyExclude', agencyIds )
      setAgencies(agencies)
    }, 100)
  }, [])

  return (
    <div className="tgbl-interface tgbl-user-accrediting-agencies">
      <h2 className="tgbl-user-accrediting-agencies__heading">Your Licenses and Certifications</h2>
      { tangibleFields.render({ type: "hidden", name: "exclude_agencies", value: [] }) }
      <div className="tgbl-user-accrediting-agencies__list">
        { agencies.map( (item, index) => <AgencyItem
          key={item.counter}
          id={item.counter}
          userID={userID}
          data={item.data}
          demographicData={demographicData}
          updateDemographics={setDemographicData}
          save={ data => {
            setAgencies( oldData => {
              const newData = JSON.parse(JSON.stringify(oldData))
              newData[index] = { counter: item.counter, data: { ...data } }
              return newData
            })
          }}
          deleteItem={() => setAgencies( oldData => {
            const newData = JSON.parse(JSON.stringify(oldData))
            newData.splice(index, 1)
            return newData
          })}
        /> )}
      </div>
      <button
        className="tgbl-button tgbl-button--theme-primary tgbl-button--style-rounded add-new-agency"
        type="button"
        onClick={() => {
          setAgencies([ ...agencies, { counter: counter, data: {} } ])
          setCounter(old => old + 1)
        }}
        disabled={ agencies.length && JSON.stringify(agencies[ agencies.length - 1 ].data) === '{}' }
      >Add New License or Certification</button>
    </div>
  )
}
